import { parseISO, format, differenceInYears } from 'date-fns'

export default {
	getFullName(patient) {
		if (!patient) return null

		let titleBefore = ''
		if (patient.title_before?.length) {
			titleBefore = patient.title_before.endsWith('.') ? patient.title_before + ' ' : patient.title_before + '. '
		}

		const name = `${titleBefore}${patient.first_name} ${patient.last_name || ''}${patient.title_after ? ', ' + patient.title_after : ''}`.replace(/_/g, ' ').trim()
		if (name && name != 'null') return name
		return '-'
	},

	getSex(sex, t = (value) => value) {
		if (!sex) return null

		if (['M', 'm', 'Male', 'male'].includes(sex)) {
			return t('Muž')
		} else if (['F', 'f', 'Female', 'female'].includes(sex)) {
			return t('Žena')
		}

		return null
	},

	formatBirthday(birthDate) {
		try {
			const dateObject = parseISO(birthDate)
			return format(dateObject, 'd.M.yyyy')
		} catch (error) {
			return birthDate
		}
	},

	getAge({ birth_date }) {
		const birthDate = parseISO(birth_date)
		const today = new Date()
		return differenceInYears(today, birthDate)
	},

	getAddressStreetNumber(patient) {
		if (patient?.address?.street || patient?.address?.street_number) {
			return `${patient?.address?.street || ''} ${patient?.address?.street_number || ''}`.trim()
		}

		return null
	},

	getAddressCityZip(patient) {
		if (!patient?.address?.city && !patient?.address?.zip) {
			return null
		}

		const zip = patient?.address?.zip || patient?.address?.zip_code
		const city = patient?.address?.city?.name || patient?.address?.city

		return `${city || ''}, ${zip || ''}`.trim()
	},

	getFullAddress(patient) {
		let address = ''

		if (patient.address?.street) address += patient.address.street

		if (patient.address?.street_number) address += address?.length ? ' ' + patient.address.street_number : ''

		const zip = patient.address?.zip || patient.address?.zip_code
		const city = patient.address?.city?.name || patient.address?.city

		if (zip) address += address?.length ? ', ' + zip : ''

		if (city) address += address?.length ? ', ' + city : ''

		if (patient.address?.country) address += address?.length ? ', ' + `${patient.address.country.name} (${patient.address.country.code})` : ''

		address = address.trim()

		return address?.length ? address : null
	},

	// Fields utils
	requireInsuranceCountry(patient) {
		return patient?.insurance_company?.required_country || false
	},
	disableInsuranceCountry(patient) {
		return patient?.insurance_company?.required_eu_accepted || this.isUkraineInsurance(patient) || false
	},
	isSlovakInsurance(patient) {
		return ['2500', '2400', '2700'].includes(patient?.insurance_company?.external_id)
	},
	isEuInsurance(patient) {
		return ['25EU_VEREJNE', '24EU', '27EU'].includes(patient?.insurance_company?.external_id)
	},
	isEuPublicInsurance(patient) {
		return ['25EU_NEODKLADNA'].includes(patient?.insurance_company?.external_id)
	},

	isUkraineInsurance(patient) {
		return ['UADO', 'UATR'].includes(patient?.insurance_company?.external_id)
	},

	isUkraineTransitInsurance(patient) {
		return ['UATR'].includes(patient?.insurance_company?.external_id)
	},
	isNonUkraineTransitInsurance(patient) {
		return ['7000'].includes(patient?.insurance_company?.external_id)
	},
	isSelfInsured(patient) {
		return ['5501'].includes(patient?.insurance_company?.external_id)
	},
	isHomelessInsurance(patient) {
		return ['6000'].includes(patient?.insurance_company?.external_id)
	},
	requiredInsuranceId(patient) {
		if (this.isSlovakInsurance(patient)) return false // For slovak insurance, insurance number is handled by requireReplacementBirthNumber

		return patient?.insurance_company?.required_insurance_id || false
	},
	requireReplacementBirthNumber(patient) {
		return this.isSlovakInsurance(patient) && patient.is_foreign === true
	},
	displayReplacementBirthNumber(patient) {
		return this.isUkraineTransitInsurance(patient) || this.requireReplacementBirthNumber(patient)
	},
	disableBirthNumber(patient) {
		return patient.is_foreign == true || this.isUkraineTransitInsurance(patient) || this.isNonUkraineTransitInsurance(patient)
	},

	disableBirthDateSex(patient) {
		return patient.is_foreign === false
	},
	documentRequired(patient) {
		return patient?.insurance_company?.required_document_scan || false
	},
	isDocumentExpired(patient) {
		const validTo = patient?.document?.valid_to || null

		if (!validTo) return false

		return validTo && new Date(validTo) < new Date()
	},
	documentDateFromRequired(patient) {
		return patient?.insurance_company?.required_document_date_from || false
	},
	documentDateToRequired(patient) {
		return patient?.insurance_company?.required_document_date_to || false
	},
	documentDescriptionLabel(patient) {
		if (!patient?.insurance_company?.document_scan_description?.length) return null

		// Transform first letter to lowercase
		const firstCharLowerCase = patient?.insurance_company?.document_scan_description.charAt(0).toLowerCase() + patient?.insurance_company?.document_scan_description.slice(1)

		// Remove . from the end
		return firstCharLowerCase.endsWith('.') ? firstCharLowerCase.slice(0, -1) : firstCharLowerCase
	}
}
